<template>
  <div class="cus-table">
    <!-- <el-checkbox v-if="cusMul" class="check-all" v-model="checkedAll" @change="changeCheckAll"></el-checkbox> -->
    <el-table
      ref="elTable"
      :stripe="stripe"
      class="table"
      :class="className"
      :data="tableData"
      :span-method="orderSpanMethods"
      :cell-style="orderCellStyle"
      :row-class-name="orderRowClass"
      :border="border"
      style="width: 100%"
      max-height="570px"
      @selection-change="handleSelectionChange"
    >
      <!--   :height="height" -->
      <el-table-column
        v-if="multiple"
        align="center"
        type="selection"
        width="55"
      ></el-table-column>
      <el-table-column
        v-if="showIndex"
        align="center"
        label="序号"
        type="index"
        width="55"
      ></el-table-column>
      <template v-for="(item, index) in labels">
        <!-- {{ item }} -->
        <el-table-column
          v-if="item.slot"
          :key="index"
          header-align="center"
          :align="item.align"
          :label="item.label"
          :min-width="item.width"
        >
          <template slot-scope="scope">
            <slot :name="item.slot" :row="scope.row" :label="item"></slot>
          </template>
        </el-table-column>
        <el-table-column
          v-else
          :key="index"
          header-align="center"
          :prop="item.prop"
          :align="item.align ? item.align : 'left'"
          :label="item.label"
          :min-width="item.width ? item.width : 200"
        ></el-table-column>
      </template>
      <el-table-column
        v-if="showOperate"
        :fixed="isFixed ? fixedValue : false"
        align="center"
        label="操作"
        :min-width="operateWidth"
      >
        <template slot-scope="scope">
          <slot name="btngroup" :row="scope.row" :index="scope.$index"></slot>
        </template>
      </el-table-column>
    </el-table>
    <el-row v-if="showPagination" class="pagination">
      <el-pagination
        :current-page="pageIndex"
        :page-size="pageSize"
        :page-sizes="[5, 10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </el-row>
  </div>
</template>
<script>
/*
 * 使用说明：
 * 1. 参数说明见props
 * 2. labels 格式:
 *    [
 *     {
 *       prop: '',  // <el-table-column>的prop, 使用slot时可不传
 *       label: '', // <el-table-column>的label, 必须
 *       width: '', // <el-table-column>的width, 可选
 *       slot: '' // 可选, 单元格使用template渲染模板时传入
 *      },
 *      ...
 *    ]
 */
export default {
  name: 'CusTable',
  props: {
    height: String, // 可选，需固定高度时传入
    border: Boolean, // 是否边框
    tableData: Array, // 表格数据
    labels: Array, // 表头展示, 详见使用说明第2条
    pageIndex: {
      // 当前页
      type: Number,
      default: 1,
    },
    pageSize: {
      // 当前页展示条数
      type: Number,
      default: 10,
    },
    totalCount: {
      // 总条数
      type: Number,
      default: 0,
    },
    operateWidth: {
      // 操作栏最小宽度
      type: Number,
      default: 100,
    },
    objectSpanMethod: {
      // 列合并方法
      type: Function,
      default: null,
    },
    className: String, // 自定义类名
    multiple: Boolean, // 是否多选
    showIndex: Boolean, // 是否显示序号
    showPagination: Boolean, // 是否展示分页
    showOperate: Boolean, // 是否展示操作栏
    stripe: {
      // 是否展示斑马条纹
      type: Boolean,
      default: true,
    },
    isFixed: {
      // 是否固定操作栏
      type: Boolean,
      default: true,
    },
    fixedValue: {
      type: String,
      default: 'right',
    },
    cusMul: Boolean, // 自定义全选（订单列表: true）- 此项暂时无用
  },
  data() {
    return {
      checkedAll: false, // 当前面全部
    };
  },
  methods: {
    handleSelectionChange(val) {
      this.$emit('handleSelectionChange', val);
    },
    handleSizeChange(val) {
      this.$emit('handleSizeChange', val);
    },
    handleCurrentChange(val) {
      this.$emit('handleCurrentChange', val);
    },
    // 订单列表订单号展示栏合并
    orderSpanMethods({ row, column, rowIndex, columnIndex }) {
      if (this.objectSpanMethod) {
        return this.objectSpanMethod({ row, column, rowIndex, columnIndex });
      }
      if (!this.$parent._orderSpanMethods) return false;
      return this.$parent._orderSpanMethods({
        row,
        column,
        rowIndex,
        columnIndex,
      });
    },
    orderCellStyle({ row, column, rowIndex, columnIndex }) {
      if (!this.$parent._orderCellStyle) return false;
      return this.$parent._orderCellStyle({
        row,
        column,
        rowIndex,
        columnIndex,
      });
    },
    orderRowClass(p) {
      if (!this.$parent._orderRowClass) return false;
      return this.$parent._orderRowClass(p);
    },
    changeCheckAll(checked) {
      this.$emit('changeCheckAll', checked);
    },
    toggleRowSelection(row, value) {
      this.$refs?.elTable?.toggleRowSelection(row, value);
    },
  },
};
</script>
<style lang="scss">
.cus-table {
  overflow-x: auto;
  position: relative;
  .check-all {
    position: absolute;
    top: 13px;
    left: 10px;
  }
}
.pagination {
  margin: 10px 0;
  text-align: right;
}
</style>
